export const serialed = (fn) => {
	let isRunning = false
	return async (...args) => {
		try {
			if (isRunning) return
			isRunning = true
			const res = await fn(...args)
			isRunning = false
			return res
		} catch (e) {
			isRunning = false
			throw e
		}
	}
}

/**
 * 倒计时
 * @param time
 * @param callback
 * @param space
 */
export const useCountdown = (time, callback, space = 1000) => {
	let current = time
	const params = () => ({ done: current === 0, current })
	const doTask = (runable) => {
		setTimeout(runable, space)
		callback(params())
	}
	const handler = () => {
		if (current <= 0) return
		current--
		doTask(handler)
	}
	doTask(handler)
}
/**
 * @description 乘法精度
 * @param {number} num1
 * @param {number} num2
 * @returns
 */
export const numMulti = (num1, num2) => {
	let baseNum = 0
	num1 = num1 || 0
	num2 = num2 || 0
	try {
		baseNum += num1.toString().split('.')[1].length
	} catch (e) {
		console.log(e)
	}
	try {
		baseNum += num2.toString().split('.')[1].length
	} catch (e) {
		console.log(e)
	}
	return (
		(Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', ''))) /
		Math.pow(10, baseNum)
	)
}

/**
 * 节流和防抖
 * 主要为了防止节流函数最后一次时间不够的情况下不执行
 * */
export function throttleWithDebounce(handler, second) {
	let lastTs = 0
	let dTimer = null
	return function(...argv) {
		if (typeof handler !== 'function') return
		clearTimeout(dTimer)
		dTimer = setTimeout(() => {
			handler(...argv)
		}, second)
		const currentTs = new Date().getTime()
		if (currentTs - lastTs < second) return
		lastTs = currentTs
		handler(...argv)
	}
}

/**
 * 校验中文
 * @param input
 * @returns {boolean}
 */
export function isChinese(input) {
	return /^[\u4E00-\u9FA5]+$/.test(input)
}

export function sleep(sec = 0) {
	return new Promise((resolve) => setTimeout(resolve, sec))
}
